import { Component, Inject } from '@angular/core';
import { ListBase } from "../shared/list.base";
import { CrewPermissionsService } from '../../core/crew-permissions.service';

@Component({
    selector: 'crew-jobroletypes',
    template: require('../shared/list-view.html')
})
export class JobRoleTypes extends ListBase<Nema.Crew.Model.RoleType>  {
    constructor(
        @Inject("jobRoleTypes") jobRoleTypes: Nema.Crew.Model.RoleType[],
        crewPermissionsService: CrewPermissionsService) {

        super(jobRoleTypes, crewPermissionsService);
    }

    public newEntityState = "app.settings.jobroletypes.new";

    public editEntityState = "app.settings.jobroletypes.detail";

    public entityName = "Job Role";

    public entityNames = "Job Roles";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/jobroletypes/jobroletypes.component.ts